import React from 'react';
import type ScreensPageType from '@jira/admin-pages__screens-page/src/ScreensPage.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyScreensPage = lazyForPaint<typeof ScreensPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-screens-page", jiraSpaEntry: "async-jira-admin-pages-screens-page" */ '@jira/admin-pages__screens-page/src/ScreensPage.tsx'
		),
	),
);

const AsyncScreensPage = (): React.JSX.Element => (
	<LazyPage Page={LazyScreensPage} pageId="jira-admin-pages-screens-page" shouldShowSpinner />
);

export default AsyncScreensPage;
